import { LitElement, html, svg } from 'lit';

export class IconCirclePlus24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Sirkel med pluss</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 7.5v9M7.5 12h9M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25Z"></path></svg>`; }
}
if (!customElements.get('f-icon-circle-plus24', IconCirclePlus24)) {
  customElements.define('f-icon-circle-plus24', IconCirclePlus24);
}